<template>
<div class="chapter">
<div class="inner_page">
<p class="imgcenter"><img alt="image" id="img11_3" src="images/img11_3.jpg"/></p>
<p class="caption">Trainee officers on a route march; The man without a hat is Louis Swift the son of a millionaire. WW1/US003</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01m_AMERICAN_EXPEDITIONARY_FORCE.vue?8ca8854e